import api from '@/services/api';

const UnreadUserContractScenario = {
  deleteUnreadUserContract: userContractHeadId => {
    return api.post('delete_unread_user_contract/', {
      user_contract_head_id: userContractHeadId
    });
  }
};

export default UnreadUserContractScenario;



// WEBPACK FOOTER //
// ./src/api/user_contract/unread_user_contract/scenario.js